@use 'style/utils';
@use 'tag-config' as tags;

$_CLASS: '.joy-tag';

@mixin tagColor() {
    @each $color, $states in tags.$TAG_COLOR_CONFIG {
        $tagNormal : map-get($states, normal);
        $tagHover : map-get($states, hover);

        #{$_CLASS}_#{$color} {
            $border: map-get($tagNormal, border);
            
            color: map-get($tagNormal, color);
            background-color: map-get($tagNormal, background-color);

            @if $border {
                border: $border;
            }
        }
    }
}

@mixin tagCta() {
    @each $color, $states in tags.$TAG_COLOR_CONFIG {
        $tagHover : map-get($states, hover);
        $tagActive : map-get($states, active);

        @if $tagHover {
            #{$_CLASS}_#{$color}.joy-tag__has-link:hover, #{$_CLASS}_#{$color}.joy-tag__selected {
                color: map-get($tagHover, color);

                $boxShadow: map-get($tagActive, box-shadow);
                $border: map-get($tagActive, border);
                @if $boxShadow {
                    box-shadow: $boxShadow;
                }

                @if $border {
                    border: $border;
                }
            }
        }

        @if $tagActive {
            #{$_CLASS}_#{$color}.joy-tag__has-link:active {
                color: map-get($tagActive, color);
                background-color: map-get($tagActive, background-color);
            }
        }
    }
}

@mixin tagSize() {
    @each $size, $value in tags.$TAG_SIZE_CONFIG {
        #{$_CLASS}_#{$size} {
            $size: map-get($value, font-size);
            $iconSize: map-get($value, iconSize);

            font-size: $size;
            padding: map-get($value, padding);
            min-height: map-get($value, height);

            @if $iconSize {
                ::slotted(joy-icon) {
                    --icon-size: #{$iconSize};
                }
            }
        }
    }
}

:host {
    display: inline-flex;
}

#{$_CLASS} {
    @include tags.tagShape();
    font-family: var(--joy-font-family-base);
    line-height: 1;
    font-weight: normal;

    joy-icon, ::slotted(joy-icon) {
        color: inherit;
        z-index: 1;
    }

    &:before {
        content: "";
        position: absolute;
        left: -1px;
        top: -1px;
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        transition: box-shadow 150ms;
        border-radius: var(--joy-core-radius-3);
    }

    &:focus-visible {
        &::before {
            box-shadow: 0 0 0 2px var(--joy-color-neutral-60);
        }
    }
}

#{$_CLASS}#{$_CLASS}_draggable {
    cursor: grab;
}

#{$_CLASS}__selectable {
    cursor: pointer;
}

#{$_CLASS}__removable {
    &, &:hover, &:active {
        margin-left: var(--joy-core-spacing-2);
        cursor: pointer;
    }
}

#{$_CLASS}__drag {
    margin-right: var(--joy-core-spacing-2);
}

@include tagColor();
@include tagSize();
@include tagCta();